import type { UseMutationOptions } from "@tanstack/vue-query";
import { useMutation, useQueryClient } from "@tanstack/vue-query";
import type {
  TodoComment,
  TodoCommentUpsertPayload,
} from "@/components/MyStudents/Submissions/components/InternalComments/types";
import { TODO_COMMENTS_QUERY_KEY_PREFIX } from "@/components/MyStudents/Submissions/composables/useTodoComments";
import profileService from "@/services/profile.js";

export interface UpsertTodoCommentVariables {
  applicationId: string;
  todoId: string;
  payload: TodoCommentUpsertPayload;
}

export const useUpsertTodoComment = (
  useMutationOptions?: UseMutationOptions<TodoComment | undefined, Error, UpsertTodoCommentVariables>,
) => {
  const queryClient = useQueryClient();

  return useMutation<TodoComment | undefined, Error, UpsertTodoCommentVariables>({
    mutationFn: async ({ applicationId, todoId, payload }) => {
      const response = await profileService.upsertTodoComment(applicationId, todoId, payload);
      return response?.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [TODO_COMMENTS_QUERY_KEY_PREFIX] });
    },
    ...useMutationOptions,
  });
};
